<template>
  <div class="d-flex justify-content-center">
    <div class="login-box">
      <div class="login-logo">
        <!-- <b>AGS Logistika</b> -->
        <div class="d-flex justify-content-center">
          <img src="@/assets/img/Logo BUP dan BP.png" 
            class="img-square elevation-3" 
            alt="User Image" 
            style="height: 100px; width: 100px">
        </div>
      </div>
      <!-- /.login-logo -->
      <div class="card">
        <div class="card-body login-card-body">
          <p class="login-box-msg">Sign in to start your session</p>

          <form @submit="submitLogin" method="post">

            <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="Username" v-model="username">
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fas fa-user"></span>
                </div>
              </div>
            </div>
            <div class="input-group mb-3">
              <input type="password" class="form-control" placeholder="Password" v-model="password">
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fas fa-lock"></span>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- /.col -->
              <div class="col-12">
                <button type="submit" class="btn btn-primary btn-block">Sign In</button>
              </div>
              <!-- /.col -->
            </div>

          </form>
          
          <p class="mt-2 mb-0 text-center">
            <b-link :to="{name: 'Register' }">
              Register a new member
            </b-link>
          </p>
        </div>
        <!-- /.login-card-body -->
      </div>
    </div>
    <!-- /.login-box -->
  </div>
</template>

<script>
import {login} from "@/services/login";
import {setUserToken} from "@/helpers/Utils";
import {getUser} from "@/services/users";
import { BLink } from 'bootstrap-vue';
import {getMemberByID} from "@/services/members";
import {clearUserData} from "@/helpers/Utils";

export default {
  name: "Login",
  components: { BLink },
  data: ()=>({
    username: null,
    password: null,
  }),
  methods: {
    async submitLogin(e) {
      try {
        e.preventDefault();
        const {data: {data: {login: res}}} = await login({
          username: this.username,
          paswd: this.password,
        })
        setUserToken(res.token);
        const {data: {data: {rows: {user}}}} = await getUser(res.username);
        const {data: {data: members }} = await getMemberByID(user.member);
        user.company = null;
        if (members && Object.prototype.hasOwnProperty.call(members, 'rows')) {
          user.company = members.rows.member;
        }
        
        await this.$store.dispatch('user/USER_LOGGED_IN', user);
        
        // Driver with no member company restriction
        if((user.role == 'member' || user.role == 'memberadmin') && user.company == null){  
          clearUserData();
          switch(user.role){
            case 'member':
              this.$bvToast.toast(`You're a driver with no member company.`,{
                title: `Welcome ${user.username}!`,
                autoHideDelay: 1500,
                variant: 'warning',
              })
              break;
            case 'memberadmin':
              this.$bvToast.toast(`You're a trucking administrator with no member company.`,{
                title: `Welcome ${user.username}!`,
                autoHideDelay: 1500,
                variant: 'warning',
              })
              break;
          }
          return;
        }

        // Redirect based on role
        if(user.role == 'member'){
          await this.$router.replace({ name: 'Permits' })
        }else{
          await this.$router.replace({ name: 'Dashboard' })
        }

        this.$bvToast.toast(`You have successfully logged in as ${user.username}. Now you can start to explore!`,{
          title: `Welcome ${user.username}!`,
          autoHideDelay: 1500,
          variant: 'success',
        })
      } catch (err) {
        // this.$bvToast.toast(`Error: ${err.message}`,{
        //   title: `Error`,
        //   autoHideDelay: 1500,
        //   variant: 'danger',
        // })
        console.error(err)
      }
    },
  },
  created() {
    document.body.className = 'login-page';
  },
}
</script>

<style scoped>

</style>
